<template>
  <div class="app">
    <router-view></router-view>
    <div class="print-container el-dialog finance-info-dialog"></div>
  </div>
</template>

<script>

export default {
  name: 'App',
  created () {
    let userInfo
    if (sessionStorage.getItem('user_info')) {
      userInfo = JSON.parse(sessionStorage.getItem('user_info'))
    } else {
      // 兼容火狐评卷，sessionStorage问题
      userInfo = JSON.parse(localStorage.getItem('user_info'))
    }
    // 如果是正式账号 就显示页面顶部的企业微信客服, 不显示下方的腾讯智能客服
    if (userInfo && userInfo.organization.costType === '0') {
      document.body.classList.add('hide-bottom-content')
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  width: 100%;
  height: 100%;
}
.print-container{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue